import * as Sentry from '@sentry/browser'

const FACTORIAL_DATA_COOKIE = '_factorial_data'

function getCookie(name: string) {
  const cookiestring = RegExp(name + '=[^;]+').exec(document.cookie)
  if (!cookiestring) return null
  return decodeURIComponent(cookiestring.toString().replace(/^[^=]+./, ''))
}

type FactorialData = {
  accessId: number
  userId: number
  companyId: number
  locale: string
  isFactorial: boolean
}

export function getFactorialData() {
  const cookie = getCookie(FACTORIAL_DATA_COOKIE)
  if (!cookie) return null

  try {
    const json = JSON.parse(cookie)

    const data: FactorialData = {
      accessId: json.access_id,
      userId: json.user_id,
      companyId: json.company_id,
      locale: json.locale,
      isFactorial: json.is_factorial,
    }
    return data
  } catch (error) {
    Sentry.setTag('cookie', true)
    Sentry.setExtra('Error parsing _factorial_data cookie', cookie)
    Sentry.captureException(error, {})

    return null
  }
}
